"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchCapable = void 0;
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    }
    catch (e) {
        return false;
    }
}
exports.isTouchCapable = isTouchCapable;
//# sourceMappingURL=touch.js.map